export default __webpack_public_path__ + "d9228c21999787743d27ad472551a035.svg";